import i18n from '@/lang/i18n'
import { Formatter } from '@/filters/formatter'
import { StatisticalAnalysisDossiersExternalInfo } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { Nullable } from '@/shared/types/app.types'
import { Options, PointLabelObject, TooltipFormatterContextObject } from 'highcharts'

const extendedChartOptions =
    (): Options => ({
        chart: {
            type: 'column',
            height: (9 / 16 * 100) + '%' // 16:9 ratio
        },
        xAxis: {
            crosshair: true
        },
        yAxis: {
            min: 0,
            title: {
                text: i18n.tc('statisticalAnalysis.charts.totalIncidents')
            }
        },
        tooltip: {
            formatter: function() {
                const context: TooltipFormatterContextObject = this
                const points: TooltipFormatterContextObject[] = context.points!
                const header: string = `<span>${context.x}</span><br>`
                let series: string = ''
                points.forEach((point: TooltipFormatterContextObject) => {
                    series += `<span style="color:${point.color}">${point.series.name}</span>: <b> ${Formatter.number(point.y, true)}</b><br/>`
                })
                return header + series
            },
            shared: true,
            useHTML: true
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    formatter: function() {
                        const context: PointLabelObject = this
                        return `${Formatter.number(context.y, true)}`
                    }
                }
            }
        },
        series: []
    })

export interface StatisticalAnalysisExternalViewDetailChartState {
    externalInfo: Nullable<StatisticalAnalysisDossiersExternalInfo>
    extendedChartOptions: Options
    modalShown: boolean
}
export const initialStatisticalAnalysisExternalViewDetailChartState =
    (): StatisticalAnalysisExternalViewDetailChartState => ({
        externalInfo: null,
        extendedChartOptions: extendedChartOptions(),
        modalShown: false
    })
